module.exports = __webpack_public_path__ + "images/388ff4084fecc39cd3540fee0348e85f.gif";